var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DxCheckBox',{attrs:{"on-value-changed":_vm.onSelectionChanged,"validationMessageMode":_vm.validationMessageMode,"text":_vm.getLabelText,"rtlEnabled":true,"element-attr":_vm.checkBoxAttributes}})}
var staticRenderFns = []

export { render, staticRenderFns }